<script setup lang="ts">
import dayjs from 'dayjs'

const props = withDefaults(
  defineProps<{
    value?: string | number | null
    /** 显示格式：full 完整时间；short 紧凑时间（列表场景，完整时间见 tooltip） */
    format?: 'full' | 'short'
  }>(),
  { format: 'full' },
)

const formatted = () => {
  if (!props.value) return '—'
  return dayjs(props.value).format(props.format === 'short' ? 'MM-DD HH:mm' : 'YYYY-MM-DD HH:mm:ss')
}

const full = () => (props.value ? dayjs(props.value).format('YYYY-MM-DD HH:mm:ss') : '')
</script>

<template>
  <!-- 紧凑格式下 tooltip 补全完整时间；完整格式本身即完整时间，无需重复提示 -->
  <a-tooltip v-if="value && format === 'short'" :title="full()">
    <span class="cursor-default whitespace-nowrap text-xs text-gray-500">{{ formatted() }}</span>
  </a-tooltip>
  <span v-else-if="value" class="cursor-default whitespace-nowrap text-xs text-gray-500">{{ formatted() }}</span>
  <span v-else class="text-xs text-gray-300">—</span>
</template>
